import { Capacitor } from '@capacitor/core';
import toast from 'react-hot-toast';
import Message from '../components/Message/Message';

export const getIsMobile = () => {
  const platform = Capacitor.getPlatform();
  return ['android', 'ios'].includes(platform);
};

export const getIsIos = () => {
  const platform = Capacitor.getPlatform();
  return ['ios'].includes(platform);
};

export const isMobileScreen = (): boolean => window.innerWidth <= 720;

export const isValidUrl = (urlString) => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  );
  return !!urlPattern.test(urlString);
};

export const isTimeExpired = (startTime: number, duration: number): boolean => {
  const now = new Date();
  return now > new Date(startTime + duration);
};

export const translatedToast = (id: string) => {
  toast(() => <Message id={id} />);
};

export const isValidDate = (dateStr: string): boolean =>
  !isNaN(new Date(dateStr).getDate());
